'use client';

import { useQuery } from '@tanstack/react-query';

import { createApiMeta } from '@/services/react-query/api-meta';

import { getMyUser, GetMyUserApiErrorCodes } from './get-my-user';

export const getMyUserQueryKey = () => ['auth', 'get-my-user'] as const;

export const useGetMyUser = (enabled = true) => {
  return useQuery({
    queryKey: getMyUserQueryKey(),
    queryFn: () => getMyUser({}),
    enabled,
    retry: false,
    staleTime: Infinity,
    meta: createApiMeta<GetMyUserApiErrorCodes>({}),
  });
};
